import { render, staticRenderFns } from "./TypeformShopping.vue?vue&type=template&id=0351a8fa&"
import script from "./TypeformShopping.vue?vue&type=script&lang=js&"
export * from "./TypeformShopping.vue?vue&type=script&lang=js&"
import style0 from "./TypeformShopping.vue?vue&type=style&index=0&id=0351a8fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports